import React, { useEffect, useState } from 'react'
import { FaUserAlt, FaLock, FaTasks } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LogInSchema } from './LoginSchema';
import { SignInRes, SignInTodo } from '../../LMS_Redux/LMS_Slices/Assets/SignIn';
import { roleListRes, roleListTodo } from '../../LMS_Redux/LMS_Slices/Assets/RoleList';
import PropagateLoader from "react-spinners/PropagateLoader";
import { Spinner } from 'react-bootstrap';
import { useTour } from '@reactour/tour';

export default function LOGIN(props) {

    const { setSidebar } = props;
    const { setIsOpen, setCurrentStep } = useTour();
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const role = useSelector(state => state.roleList && state.roleList.data && state.roleList.data.data)
    const [loading, setLoading] = useState(false)
    const [spinner, setSpinner] = useState(false)
    // console.log(role)

    const initialValues = {
        username: '',
        password: '',
        role: ''
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues: initialValues,
        validationSchema: LogInSchema,

        onSubmit: (values, action) => {
            // console.log(values)
            setSpinner(true)
            dispatch(SignInTodo(values)).then(() => login_user(action))
            // action.resetForm();
        },
    })

    const login_user = (action) => {
        // console.log(SignInRes.data[0])
        if (SignInRes && SignInRes.success) {
            localStorage.setItem('user_data', JSON.stringify(SignInRes.data[0]))
            localStorage.setItem('tour_toggle', SignInRes?.data[0]?.tour_status)
            action.resetForm();
            setSidebar(true)
            toast.success("SignIn Successfully!!..", { position: "bottom-right" });
            // localStorage.setItem('token', SignInRes.data[0].token.access_token)
            navigate(SignInRes && SignInRes.data && SignInRes.data[0].vrole_name == "Learner" ? '/learner-dashboard' : '/dashboard')
            setSpinner(false)
            if (SignInRes.data[0].vrole_name === "Learner") {
                if (SignInRes?.data[0]?.tour_status) {
                    setCurrentStep(0);
                    setIsOpen(true)
                }
            } else {
                setIsOpen(false)
            }
        } else {
            toast.error(SignInRes.message, { position: "bottom-right" });
            setSpinner(false)
        }
    }

    const user_base_role = (e) => {
        // console.log(e.target.value)
        dispatch(roleListTodo(e.target.value)).then(() => roll_res())
    }

    const roll_res = () => {
        if (roleListRes && roleListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    return (
        <>
            <div className='login_bg'>
                <div className="container h-100">
                    <div className="row justify-content-center h-100">
                        <div className="col-12 col-lg-6 my-auto order-2 order-md-1">
                            <img src="../Images/login-banner.png" alt="login" className='img-fluid' />
                        </div>

                        <div className="col-12 col-lg-6 my-auto order-1 order-md-2">
                            <div className='login_details'>
                                <div className='text-center'>
                                    <img src="./rexolms.png" className='img-fluid' alt="logo" style={{ height: '40px' }} />
                                    {/* <p style={{ color: '#2262c6', fontSize: '2.5rem', fontWeight: '500' }}>LMS</p> */}
                                </div>
                                <div className='login_details1'>
                                    <h2>Sign In</h2>
                                    <p>Let's get started !!...</p>
                                </div>

                                {/* {loading ?
                                    <div className='text-center mb-3'>
                                        <PropagateLoader
                                            color="#2262C6"
                                            size={20}
                                        />
                                    </div>
                                    : */}
                                <form method="post" onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                                    <div className="form-floating mb-3">
                                        <input type="text" className="form-control login_input" id="floatingInput" placeholder="name@example.com"
                                            name='username'
                                            value={values.username}
                                            onChange={handleChange}
                                            onBlur={(e) => { handleBlur(e); user_base_role(e) }}
                                        />
                                        <label htmlFor="floatingInput"><FaUserAlt size={18} className='mb-1 me-2' />Username</label>
                                        {errors.username && touched.username ? (<span className='text-danger' >{errors.username}</span>) : null}
                                    </div>

                                    <div className="form-floating mb-3">
                                        <input type="password" className="form-control login_input" id="floatingPassword" placeholder="Password"
                                            name='password'
                                            value={values.password}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        <label htmlFor="floatingPassword"><FaLock size={18} className='mb-1 me-2' />Password</label>
                                        {errors.password && touched.password ? (<span className='text-danger' >{errors.password}</span>) : null}
                                    </div>

                                    <div className="form-floating mb-3">
                                        <select className="form-select login_input" id="floatingSelect" aria-label="Floating label select example"
                                            name='role'
                                            value={values.role}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        >
                                            <option value=''>Select Role</option>
                                            {role && role.map((value, index) =>
                                                <option value={value.vgrade_code} key={index}>{value.vgrade_name}</option>
                                            )}
                                        </select>
                                        <label htmlFor="floatingSelect"><FaTasks size={18} className='mb-1 me-2' />Role</label>
                                        {errors.role && touched.role ? (<span className='text-danger' >{errors.role}</span>) : null}
                                    </div>

                                    <button type='submit' className='btn in_btn' disabled={spinner ? true : false}>
                                        Sign In
                                        {spinner ?
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                className='ms-2'
                                            />
                                            : ''
                                        }
                                    </button>

                                </form>
                                {/* } */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    )
}
